import { render } from "./hotel-row.vue?vue&type=template&id=85f0be02"
import script from "./hotel-row.vue?vue&type=script&lang=js"
export * from "./hotel-row.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__